import { NOVITA_UNREAD_PAGE_SIZE } from './config';
import { fetchNovita } from './novitaApi';
import {
  findNovitaUserReads,
  markNovitaItemsOpened,
  markNovitaOpened,
} from './userReadGraphql';
import { getUser } from '~src/user';
import {
  buildNovitaUnreadState,
  emptyNovitaUnreadState,
  parseSessionDate,
} from './stateUtils';

export {
  buildNovitaUnreadState,
  buildNovitaUnreadSummaryLabel,
  emptyNovitaUnreadState,
  formatNovitaUnreadCount,
  getLatestNovitaItem,
  isNovitaItemEligibleForUnread,
  isNovitaItemUnread,
  parseSessionDate,
  toNovitaTimestamp,
} from './stateUtils';

const getSessionIds = async () => {
  const startup = await getUser();
  const user = startup?.user;
  const sessionToken = startup?.userToken;
  const userId = user?.objectId;
  const orgId = user?.org_pointer?.objectId;

  if (!userId || !orgId || !sessionToken) {
    return null;
  }

  return {
    sessionToken,
    userId,
    orgId,
    userCreatedAt: parseSessionDate(user.createdAt),
  };
};

export const getCurrentNovitaSessionKey = async () => {
  const sessionIds = await getSessionIds();
  return sessionIds ? `${sessionIds.orgId}:${sessionIds.userId}` : null;
};

export const getNovitaUnreadState = async () => {
  const sessionIds = await getSessionIds();
  if (!sessionIds) return emptyNovitaUnreadState();

  const [readNodes, response] = await Promise.all([
    findNovitaUserReads(sessionIds),
    fetchNovita({ pageSize: NOVITA_UNREAD_PAGE_SIZE }),
  ]);

  return buildNovitaUnreadState({
    items: response.items,
    totalItems: response.pagination.totalItems,
    readItemIds: readNodes.map((node) => node.novita_id),
    userCreatedAt: sessionIds.userCreatedAt,
  });
};

export const saveNovitaOpened = async (input) => {
  const sessionIds = await getSessionIds();
  if (!sessionIds) return getNovitaUnreadState();

  return markNovitaOpened(sessionIds, input);
};

export const saveNovitaItemsOpened = async (input) => {
  const sessionIds = await getSessionIds();
  if (!sessionIds) return getNovitaUnreadState();

  return markNovitaItemsOpened(sessionIds, input);
};
